<template>
  <t-layout>
    <!-- <div class="list">
      <div class="item" @click="toFind">发现页</div>
      <div class="item" @click="toShopCoupon">商户优惠券</div>
    </div> -->
  </t-layout>
</template>

<script>
export default {
  name: 'homeView',
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {
    toFind() {
      this.$router.push({
        path: '/find/page?id=1642'
      })
    },
    toShopCoupon() {
      this.$router.push({
        name: 'shopCoupon'
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
